import React from 'react';
import { Grid } from '@mui/material';
import ProductCard from './building_blocks/ProductCard';

const ShopProductList = ({
  products,
  catalogProducts,
  shoppingCartProducts,
  handleAddProduct,
  changeCartQuantity,
  sx: sxProp,
}) => {
  const indexSource = catalogProducts || products;

  return (
    <Grid container spacing={2}
      sx={{
        mt: 3,
        p: 2,
        pb: shoppingCartProducts.length > 0 ? '118px' : 2,
        width: '100%',
        ...sxProp,
      }}
    >
      {products.map((product) => {
        const catalogIndex = indexSource.findIndex((item) => item.id === product.id);

        return (
          <Grid item
            xs={6} sm={4} md={3}
            key={product.id}
          >
            <ProductCard
              variant="grayCard"
              detailMode="description"
              product={product}
              productIndex={catalogIndex}
              showCartControls
              shoppingCartProducts={shoppingCartProducts}
              onAdd={() => handleAddProduct(product, catalogIndex)}
              onIncrement={() => changeCartQuantity(product.id, '+')}
              onDecrement={() => changeCartQuantity(product.id, '-')}
              sx={{ padding: '12px' }}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default ShopProductList;
